import { Icon } from 'semantic-ui-react';

/**
 * The delete icon for an entity the server cannot delete (control box, queue,
 * booth, display, kiosk).
 *
 * It used to look live: clicking it asked "Do you really want to do it?",
 * then nothing happened, and the rejected call killed the delete saga so even
 * deleting a location or service stopped working until a reload. Shown
 * disabled, with the reason on hover.
 */
export function UnsupportedDeleteIcon(props: { what: string }) {
  return (
    <Icon
      name="remove circle"
      size="large"
      disabled
      title={`Deleting a ${props.what} is not supported in this version`}
      aria-label={`Deleting a ${props.what} is not supported`}
    />
  );
}
